import { render, staticRenderFns } from "./thank-you.vue?vue&type=template&id=6bbdf626&lang=html&"
import script from "./thank-you.vue?vue&type=script&lang=js&"
export * from "./thank-you.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports